import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { RouteSignpostsService } from '../../services/route-signposts/route-signposts.service';
import { EventsService } from 'src/app/core/services/events.service';
import { AARoutePlannerEvents, AAGoogleMapEvents, MobileNavigationEvent } from 'src/app/core/events/events';
import { SummaryData } from '../../models/route-summary-model';
import { RouteSignposts, RouteLeg, RouteSignpostList } from '../../models/route-signposts-model';
import { DISTANCE_TYPE } from '../../enums/route.enum';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';
import { IMobileNavigationEventModel } from 'src/app/core/models/models';
import { AARouterURL } from 'src/app/modules/app-routing/enums/routing.enum';

@Component({
    selector: 'aa-route-signposts',
    templateUrl: './route-signposts.component.html',
    styleUrls: ['./route-signposts.component.scss'],
    standalone: false
})
export class RouteSignpostsComponent implements OnInit, OnDestroy {

  public routeSignpostList: RouteSignpostList;

  constructor(
    private appUtiltyService: AppUtilityService,
    private eventsService: EventsService,
    private cdr: ChangeDetectorRef,
    private routeSignpostsService: RouteSignpostsService) {
      this.routeSignpostList = this.routeSignpostsService.routeSignpostList;
    }

  ngOnInit() {
    this.eventsService.on(AARoutePlannerEvents.UPDATE_SIGNSPOTS, this.updateSignSpots);
    this.eventsService.on(AARoutePlannerEvents.UPDATE_SUMMARY_MATRIC, this.updateSignSpotsMatric);
  }

  ngOnDestroy() {
    this.eventsService.remove(AARoutePlannerEvents.UPDATE_SIGNSPOTS, this.updateSignSpots);
    this.eventsService.remove(AARoutePlannerEvents.UPDATE_SUMMARY_MATRIC, this.updateSignSpotsMatric);
  }

  updateSignSpots = (selectedRoute: SummaryData) => {
    this.routeSignpostsService.updateSignSpots(selectedRoute).subscribe( data => {
      this.routeSignpostList = this.routeSignpostsService.routeSignpostList;
       this.cdr.detectChanges();
    });
  }

  updateSignSpotsMatric = (distanceType: DISTANCE_TYPE) => {
    this.routeSignpostList.setDistanceType(distanceType);
    this.cdr.detectChanges();
  }

  onMouseOver(item: RouteLeg) {
    this.eventsService.dispatch(AAGoogleMapEvents.ROUTE_LEG_HOVER, {leg: item, visible: true});
  }

  onMouseOut(item: RouteLeg) {
    this.eventsService.dispatch(AAGoogleMapEvents.ROUTE_LEG_HOVER, {leg: item, visible: false});
  }

  onClicked(item: RouteLeg) {
    this.eventsService.dispatch(AAGoogleMapEvents.ROUTE_LEG_CLICK, {leg: item});

    // navigate to map tab only for mobile
    if (this.appUtiltyService.isStrictlyMobile) {
      const data: IMobileNavigationEventModel = {ActivePage: AARouterURL.ROUTE_PLANNER, ActiveTab: AARouterURL.MOBILE_MAP};
      this.eventsService.dispatch(MobileNavigationEvent.SELECT_MOBILE_MENU, data);
    }
  }
  
  trackByFn(index: number): number {
    return index;
  }
}
